<template>
  <div class="Login">
    <div class="Login__Holder">
      <div class="Login__Form">
        <h1>
          <span>engine</span>
          <span>W</span>
        </h1>
        <v-form v-model="valid">
          <v-text-field
            v-model="name"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Korisnik"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            name="password"
            label="Šifra"
            :append-icon="value ? 'visibility' : 'visibility_off'"
            @click:append="() => (value = !value)"
            :type="value ? 'password' : 'text'"
          ></v-text-field>
          <div class="formActions">
            <button block class="button--green" v-on:click="login">
              Prijavi se
            </button>

            <a href="#" class="forgotenPass">Zaboravljena sifra?</a>
          </div>
        </v-form>
        <div class="Login__Form__Info">
          <p>
            Ukoliko nemate korisnicke podatke.
            <router-link class="createAcc" to="#">kreirajte nalog </router-link>
          </p>
        </div>

        <!-- <qr-code text="Text to encode"></qr-code> -->
      </div>
      <!-- /.Login__Form -->
      <!-- <div class="Languages">
        <span href="#" class="langLink">Sr</span>
        <a href="#" class="langLink">En</a>
        <a href="#" class="langLink">Fr </a>
        <a href="#" class="langLink">Es </a>
        <a href="#" class="langLink">It</a>
      </div> -->
    </div>
    <!-- /.Login__Holder -->
  </div>
  <!-- /.Login -->
</template>

<script>
import {
  findUser,
  readJSON,
  findToken,
  findCity,
  findWinery,
  findRole,
  findIsWinery,
} from "../helpers/Functions";

export default {
  name: "Login",
  data() {
    return {
      show1: false,
      // password: "marcobra",
      // name: "marko@mkonekt.com",
      password: "",
      name: "",
      nameRules: "",
      valid: "",
      rules: {
        required: (value) => !!value || "Required.",
        emailMatch: () => "The email and password you entered don't match",
      },
      init: 0,
      value: String,
    };
  },
  methods: {
    login(e) {
      e.preventDefault();

      let username = findUser(this.name, this.password, this.globalPort);

      // alert(bool);

      if (username !== "") {
        localStorage.setItem("user-token", findToken(username));
        localStorage.setItem("vinarija", findWinery(username));
        localStorage.setItem("city", findCity(username));
        localStorage.setItem("role", findRole(username));
        localStorage.setItem("isWinery", findIsWinery(username));

        this.$parent.$parent.dajProstorije();
        this.$parent.$parent.loggedin = true;

        localStorage.setItem("loggedin", true);

        // serverBus.$emit("osvezi_meni");

      } else {
        this.$parent.$parent.loggedin = false;
        alert("Parametri za pristup nisu dobri.");

        localStorage.setItem("loggedin", false);
      }
    },
  },
  mounted() {
    if (localStorage.getItem("loggedin") !== null)
      if (localStorage.getItem("loggedin") !== "true") {
        localStorage.removeItem("loggedin");
        localStorage.removeItem("user-token");
        localStorage.removeItem("city");
        localStorage.removeItem("user-refresh-token");
        localStorage.removeItem("role");
      } else this.$parent.$parent.loggedin = true;
  },
};
</script>

<style lang="scss" scoped>
.Login {
  position: relative;
  height: 100%;
  background-color: #6c021c;
  &__Holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .Languages {
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    .langLink {
      color: #fff;
      font-family: "NunitoSans", sans-serif;
      display: inline-block;
      margin: 0 2px;
      &:after {
        content: "/";
      }
    }
  }
  &__Form {
    width: 570px;
    padding: 30px 100px;
    border-radius: 10px;
    background-color: #fff;
    h1 {
      font-size: 36px;
      font-family: "Nunito Sans", sans-serif;
      text-align: center;
      span {
        &:first-child {
          color: #6c021c;
        }
        &:last-child {
          color: #018389;
        }
      }
    }
    .formActions {
      text-align: center;
      button {
        margin-bottom: 8px;
      }
    }
    .forgotenPass {
      display: block;
      text-align: center;
      font-size: 12px;
      letter-spacing: 0px;
      color: #6c021c;
      text-decoration: underline;
    }
    &__Info {
      font-size: 12px;
      text-align: center;
      margin-top: 40px;
      letter-spacing: 0px;
      .createAcc {
        color: #018389;
      }
    }
  }
  .button--green {
    width: 185px;
    @include btn(#fff, #018389);
    padding: 7px 13px 6px;
  }
  .hidden-sm-and-down .v-icon {
    color: red !important;
  }
}
</style>
